import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import { ParagraphGroup } from "../../../components/paragraph-group";
import { ExternalLink } from "../../../components/external-link";
import { ImageTextTriplets } from "../../../components/image-text-triplets";

export interface DeveloperProps {
	sectionId: string;
	index: number;
}

export function Developer(props: DeveloperProps) {
	const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
	return (
		<Section sectionId={props.sectionId} isLast={false}>
			<SectionHeader title={`${formattedIndex} For Developers`} />
			<ParagraphGroup
				title="AI Models"
				body={[
					"Our solution features three AI models, for evaluating credibility, surfacing high-risk accounts, and recommending accounts to follow. Learn more about them here:",
				]}
			//Three icon + model links format here
			/>
			<ImageTextTriplets
				children={[
					{
						title: "1. Fact-check Model",
						body: "Powers the fact-checker in evaluating content credibility",
						link: {
							cta: "View the Model",
							url: "https://www.figma.com/file/Thyvdlyo8lQTDVGwjvg0fE/Prototype-Final?node-id=529%3A11592"
						}
					},
					{
						title: "2. Accounts to Review Model",
						body:
							"Powers the Accounts to Review feature in surfacing top misinformers, or high-risk accounts within the user's engagement",
						link: {
							cta: "View the Model",
							url: "https://www.figma.com/file/Thyvdlyo8lQTDVGwjvg0fE/Prototype-Final?node-id=529%3A11262"
						}
					},
					{
						title: "3. Accounts to Replace Misinformers Model",
						body:
							"Recommends credible accounts to replace misinformers that the user has unfollowed",
						link: {
							cta: "View the Model",
							url: "https://www.figma.com/file/Thyvdlyo8lQTDVGwjvg0fE/Prototype-Final?node-id=529%3A11134"
						}
					},
				]}
			/>

			<ParagraphGroup
				title="AI Interaction Tables"
				body={[
					"For each of these models, we have also include a table outlining the training data, inputs, logic, and outputs needed to support the implementation.",
				]}
			/>
			<ExternalLink
				url={"https://infrequent-yuzu-413.notion.site/AI-Interaction-Table-4628c49c1129441cb20bd0b66ab9ee76"}
				cta="View the Table"
				solo={true}
			/>
		</Section>
	);
}
